import { api } from '@/axios/instance/api';

export const apiFetchCompetingOffers = (params) =>
  api.get(`competing-offers?page=${params.page}${params.ordering}${params.filtering}${params.search}`);
